// Translations for FR / EN / ES / ZH (Chinese simplified)
export const translations = {
  fr: {
    nav: { home: "Accueil", expertise: "Expertise", models: "Modèles", why: "Pourquoi Hecnos", blog: "Blog", contact: "Nous contacter" },
    cookie: {
      title: "Nous respectons votre vie privée",
      body: "Ce site utilise des cookies et traceurs de connexion pour mesurer l'audience et améliorer l'expérience. Conformément au RGPD, votre consentement est requis avant tout dépôt.",
      accept: "Accepter",
      decline: "Continuer sans accepter",
      linkPrivacy: "En savoir plus",
    },
    sectors: ["Banque", "Assurance", "Énergie", "Distribution", "Industrie", "Santé", "Télécom", "Aérospatial", "Secteur public"],
    common: {
      startProject: "Démarrer un projet",
      joinAdventure: "Rejoindre l'aventure",
      seeAll: "Tout voir",
      learnMore: "En savoir plus",
      readArticle: "Lire l'article",
      watchVideo: "Voir la vidéo",
      next: "Prochaine étape",
      sendMessage: "Envoyer le message",
      sending: "Envoi...",
      response24h: "Sous 24 heures ouvrées",
      backToBlog: "Retour au blog",
    },
    hero: {
      badge: "Un collectif d'experts. Une exécution sans compromis.",
      title1: "Résolvons ensemble",
      title2: "vos défis les",
      title3: "plus complexes",
      desc: "Hecnos rassemble des experts en cybersécurité, big data, intelligence artificielle et gestion de projet pour accélérer la transformation des organisations exigeantes.",
      state: "État du collectif",
      available: "disponible · 2026 Q1",
    },
    sections: {
      expertiseKicker: "Expertises",
      expertiseTitle1: "Quatre disciplines.",
      expertiseTitle2: "Un seul niveau d'exigence.",
      expertiseDesc: "Nous concentrons nos forces là où la valeur est la plus forte : protéger, exploiter, augmenter et piloter. Nos consultants interviennent sur des missions stratégiques, sur site ou en mode delivery.",
      figuresKicker: "Chiffres clés",
      figuresTitle: "Une présence et une force de frappe à l'échelle européenne.",
      modelsKicker: "Modèles",
      modelsTitle: "Trois façons de travailler avec nous.",
      modelsDesc: "Selon la maturité de votre besoin et votre niveau de risque, nous adaptons la formule : du renfort ponctuel à la prise en charge complète d'un programme.",
      whyKicker: "Pourquoi Hecnos",
      whyTitle1: "Un collectif.",
      whyTitle2: "Pas une pyramide.",
      whyDesc: "Notre culture repose sur trois piliers : l'expertise réelle, une expérience collaborateur singulière, et un état d'esprit d'innovation continue.",
      testiKicker: "Témoignages",
      testiTitle: "Ce que disent ceux qui nous font confiance.",
      ctaTitle: "Parlons de votre prochain défi.",
      ctaDesc: "Que vous cherchiez à protéger, exploiter ou augmenter — nous avons l'équipe qu'il vous faut.",
    },
    stats: { experts: "experts", countries: "pays", clients: "clients", projects: "projets livrés" },
    expertises: {
      cyber: { title: "Cybersécurité", short: "SOC, gouvernance, audit, réponse à incident et conformité ISO 27001 / NIS2." },
      bigdata: { title: "Big Data", short: "Plateformes data, architectures lakehouse, ingestion temps réel et MLOps industrialisé." },
      ai: { title: "Intelligence Artificielle", short: "LLMs, RAG, vision par ordinateur et automatisation à l'échelle de l'entreprise." },
      pm: { title: "Gestion de projet", short: "PMO, méthodes agiles, pilotage de programmes critiques et conduite du changement." },
    },
    models: {
      m1: { title: "Assistance Technique", desc: "Consultants intégrés à vos équipes pour renforcer une compétence rare." },
      m2: { title: "Centres de Services", desc: "Équipes pilotées par Hecnos, en run ou build, avec engagements de service." },
      m3: { title: "Projets au Forfait", desc: "Engagement sur le périmètre, le délai et le budget. Risque maîtrisé." },
    },
    pillars: {
      p1: { title: "Expertise collective", desc: "Des seniors qui ont déjà livré. Pas de profils en formation déguisés en consultants." },
      p2: { title: "Expérience singulière", desc: "Mobilité interne, communautés d'expertise, formation continue, mentoring." },
      p3: { title: "Esprit innovant", desc: "R&D interne, veille active, prototypage rapide. L'innovation comme méthode." },
    },
    blog: {
      heroKicker: "Blog Hecnos",
      heroTitle1: "Insights, tutos &",
      heroTitle2: "actualité tech.",
      heroDesc: "Bonnes pratiques cybersécurité, tendances IA, architectures Big Data et nouvelles du monde IT — sélectionnés par notre collectif.",
      all: "Tous",
      categories: { cyber: "Cybersécurité", ai: "IA", bigdata: "Big Data", it: "IT" },
      featured: "À la une",
      videoTutos: "Tutos vidéo",
      latest: "Derniers articles",
      readTime: "min de lecture",
      noResults: "Aucun article dans cette catégorie pour le moment.",
    },
    contact: {
      kicker: "Contact",
      titleA1: "Parlons de", titleA2: "votre projet",
      titleB1: "Rejoignez", titleB2: "le collectif",
      desc: "Décrivez-nous votre besoin ou votre profil. Un membre de notre équipe vous répond personnellement sous 24 heures ouvrées.",
      tabContact: "Démarrer un projet",
      tabJoin: "Rejoindre l'aventure",
      name: "Nom complet *",
      email: "Email *",
      company: "Entreprise",
      phone: "Téléphone",
      subject: "Sujet",
      subjectJoin: "Poste recherché",
      message: "Votre message *",
      messageJoin: "Présentez-vous *",
      placeholderMessage: "Décrivez votre contexte, votre besoin et vos enjeux.",
      placeholderJoin: "Parcours, expertise, motivations...",
      gdpr: "En soumettant ce formulaire, vous acceptez que Hecnos traite vos données pour répondre à votre demande, conformément à notre politique de confidentialité.",
      successTitle: "Message bien reçu",
      successDesc: "Nous revenons vers vous sous 24 h ouvrées.",
      sendAnother: "Envoyer un autre message",
      findUs: "Nous trouver",
      findUsDesc: "Trois bureaux, un seul collectif.",
      addresses: "Adresses",
      response: "Réponse",
      toastSuccess: "Message envoyé. Nous revenons vers vous sous 24 h.",
      toastError: "Une erreur est survenue. Réessayez dans un instant.",
      toastValidation: "Merci de remplir nom, email et message.",
    },
    footer: {
      tagline: "Hecnos est un collectif d'experts au service des organisations qui veulent résoudre des défis complexes et accélérer leur transformation.",
      company: "Société",
      expertises: "Expertises",
      joinTitle: "Rejoignez-nous",
      joinDesc: "Nous recrutons des talents qui font la différence.",
      rights: "Tous droits réservés.",
      tag: "Conseil · Technologie · Talent",
      privacy: "Politique de confidentialité",
      terms: "Conditions d'utilisation",
    },
  },

  en: {
    nav: { home: "Home", expertise: "Expertise", models: "Models", why: "Why Hecnos", blog: "Blog", contact: "Contact us" },
    cookie: {
      title: "We respect your privacy",
      body: "This website uses cookies and connection trackers to measure audience and improve your experience. Under GDPR, your consent is required before any tracker is set.",
      accept: "Accept",
      decline: "Continue without accepting",
      linkPrivacy: "Learn more",
    },
    sectors: ["Banking", "Insurance", "Energy", "Retail", "Industry", "Healthcare", "Telecom", "Aerospace", "Public sector"],
    common: {
      startProject: "Start a project",
      joinAdventure: "Join the adventure",
      seeAll: "View all",
      learnMore: "Learn more",
      readArticle: "Read article",
      watchVideo: "Watch video",
      next: "Next step",
      sendMessage: "Send message",
      sending: "Sending...",
      response24h: "Within 24 business hours",
      backToBlog: "Back to blog",
    },
    hero: {
      badge: "A collective of experts. Execution without compromise.",
      title1: "Let's solve",
      title2: "your most",
      title3: "complex challenges",
      desc: "Hecnos brings together experts in cybersecurity, big data, artificial intelligence and project management to accelerate the transformation of demanding organizations.",
      state: "Collective status",
      available: "available · 2026 Q1",
    },
    sections: {
      expertiseKicker: "Expertise",
      expertiseTitle1: "Four disciplines.",
      expertiseTitle2: "One level of excellence.",
      expertiseDesc: "We focus our strength where value matters most: protect, exploit, augment and steer. Our consultants intervene on strategic missions, on-site or in delivery mode.",
      figuresKicker: "Key figures",
      figuresTitle: "A European-scale presence and execution power.",
      modelsKicker: "Models",
      modelsTitle: "Three ways to work with us.",
      modelsDesc: "Depending on the maturity of your need and your risk appetite, we adapt the contract — from a focused reinforcement to a full program ownership.",
      whyKicker: "Why Hecnos",
      whyTitle1: "A collective.",
      whyTitle2: "Not a pyramid.",
      whyDesc: "Our culture relies on three pillars: real expertise, a singular employee experience, and a continuous innovation mindset.",
      testiKicker: "Testimonials",
      testiTitle: "What those who trust us say.",
      ctaTitle: "Let's talk about your next challenge.",
      ctaDesc: "Whether you want to protect, exploit or augment — we have the team you need.",
    },
    stats: { experts: "experts", countries: "countries", clients: "clients", projects: "projects delivered" },
    expertises: {
      cyber: { title: "Cybersecurity", short: "SOC, governance, audit, incident response and ISO 27001 / NIS2 compliance." },
      bigdata: { title: "Big Data", short: "Data platforms, lakehouse architectures, real-time ingestion and industrialised MLOps." },
      ai: { title: "Artificial Intelligence", short: "LLMs, RAG, computer vision and enterprise-scale automation." },
      pm: { title: "Project Management", short: "PMO, agile methods, critical program steering and change management." },
    },
    models: {
      m1: { title: "Technical Assistance", desc: "Consultants embedded in your teams to reinforce a rare skill." },
      m2: { title: "Service Centers", desc: "Hecnos-led teams, in run or build, with measurable service commitments." },
      m3: { title: "Fixed-price Projects", desc: "Commitment on scope, schedule and budget. Risk under control." },
    },
    pillars: {
      p1: { title: "Collective expertise", desc: "Seniors who have already delivered. No trainees disguised as consultants." },
      p2: { title: "Singular experience", desc: "Internal mobility, expertise communities, continuous learning, mentoring." },
      p3: { title: "Innovative mindset", desc: "Internal R&D, active scouting, rapid prototyping. Innovation as a method." },
    },
    blog: {
      heroKicker: "Hecnos Blog",
      heroTitle1: "Insights, tutorials &",
      heroTitle2: "tech news.",
      heroDesc: "Cybersecurity best practices, AI trends, Big Data architectures and IT news — curated by our collective.",
      all: "All",
      categories: { cyber: "Cybersecurity", ai: "AI", bigdata: "Big Data", it: "IT" },
      featured: "Featured",
      videoTutos: "Video tutorials",
      latest: "Latest articles",
      readTime: "min read",
      noResults: "No articles in this category yet.",
    },
    contact: {
      kicker: "Contact",
      titleA1: "Let's talk about", titleA2: "your project",
      titleB1: "Join", titleB2: "the collective",
      desc: "Tell us about your need or your profile. A member of our team will reply personally within 24 business hours.",
      tabContact: "Start a project",
      tabJoin: "Join the adventure",
      name: "Full name *",
      email: "Email *",
      company: "Company",
      phone: "Phone",
      subject: "Subject",
      subjectJoin: "Target role",
      message: "Your message *",
      messageJoin: "Introduce yourself *",
      placeholderMessage: "Describe your context, your need and your stakes.",
      placeholderJoin: "Background, expertise, motivations...",
      gdpr: "By submitting this form you accept that Hecnos processes your data to answer your request, per our privacy policy.",
      successTitle: "Message received",
      successDesc: "We will get back to you within 24 business hours.",
      sendAnother: "Send another message",
      findUs: "Find us",
      findUsDesc: "Three offices, one collective.",
      addresses: "Addresses",
      response: "Response",
      toastSuccess: "Message sent. We'll get back to you within 24h.",
      toastError: "An error occurred. Please try again shortly.",
      toastValidation: "Please fill name, email and message.",
    },
    footer: {
      tagline: "Hecnos is a collective of experts serving organizations that want to solve complex challenges and accelerate their transformation.",
      company: "Company",
      expertises: "Expertises",
      joinTitle: "Join us",
      joinDesc: "We hire talents who make the difference.",
      rights: "All rights reserved.",
      tag: "Consulting · Technology · Talent",
      privacy: "Privacy policy",
      terms: "Terms of use",
    },
  },

  es: {
    nav: { home: "Inicio", expertise: "Experiencia", models: "Modelos", why: "Por qué Hecnos", blog: "Blog", contact: "Contáctenos" },
    cookie: {
      title: "Respetamos su privacidad",
      body: "Este sitio utiliza cookies y rastreadores para medir la audiencia y mejorar su experiencia. Conforme al RGPD, su consentimiento es necesario antes de cualquier registro.",
      accept: "Aceptar",
      decline: "Continuar sin aceptar",
      linkPrivacy: "Saber más",
    },
    sectors: ["Banca", "Seguros", "Energía", "Distribución", "Industria", "Salud", "Telecom", "Aeroespacial", "Sector público"],
    common: {
      startProject: "Iniciar un proyecto",
      joinAdventure: "Únase a la aventura",
      seeAll: "Ver todo",
      learnMore: "Saber más",
      readArticle: "Leer artículo",
      watchVideo: "Ver vídeo",
      next: "Próximo paso",
      sendMessage: "Enviar mensaje",
      sending: "Enviando...",
      response24h: "En 24 horas laborables",
      backToBlog: "Volver al blog",
    },
    hero: {
      badge: "Un colectivo de expertos. Ejecución sin compromisos.",
      title1: "Resolvamos juntos",
      title2: "sus retos",
      title3: "más complejos",
      desc: "Hecnos reúne a expertos en ciberseguridad, big data, inteligencia artificial y gestión de proyectos para acelerar la transformación de las organizaciones exigentes.",
      state: "Estado del colectivo",
      available: "disponible · 2026 T1",
    },
    sections: {
      expertiseKicker: "Experiencia",
      expertiseTitle1: "Cuatro disciplinas.",
      expertiseTitle2: "Un solo nivel de exigencia.",
      expertiseDesc: "Concentramos nuestras fuerzas donde el valor es mayor: proteger, explotar, aumentar y dirigir. Nuestros consultores intervienen en misiones estratégicas, en sitio o en modo delivery.",
      figuresKicker: "Cifras clave",
      figuresTitle: "Una presencia y una capacidad de ejecución a escala europea.",
      modelsKicker: "Modelos",
      modelsTitle: "Tres maneras de trabajar con nosotros.",
      modelsDesc: "Según la madurez de su necesidad y su tolerancia al riesgo, adaptamos la fórmula — del refuerzo puntual al programa completo.",
      whyKicker: "Por qué Hecnos",
      whyTitle1: "Un colectivo.",
      whyTitle2: "No una pirámide.",
      whyDesc: "Nuestra cultura se basa en tres pilares: experiencia real, una experiencia de colaborador singular y una mentalidad de innovación continua.",
      testiKicker: "Testimonios",
      testiTitle: "Lo que dicen quienes confían en nosotros.",
      ctaTitle: "Hablemos de su próximo reto.",
      ctaDesc: "Ya sea para proteger, explotar o aumentar — tenemos el equipo que necesita.",
    },
    stats: { experts: "expertos", countries: "países", clients: "clientes", projects: "proyectos entregados" },
    expertises: {
      cyber: { title: "Ciberseguridad", short: "SOC, gobernanza, auditoría, respuesta a incidentes y cumplimiento ISO 27001 / NIS2." },
      bigdata: { title: "Big Data", short: "Plataformas de datos, arquitecturas lakehouse, ingestión en tiempo real y MLOps industrializado." },
      ai: { title: "Inteligencia Artificial", short: "LLMs, RAG, visión por computadora y automatización a escala empresarial." },
      pm: { title: "Gestión de proyectos", short: "PMO, métodos ágiles, dirección de programas críticos y gestión del cambio." },
    },
    models: {
      m1: { title: "Asistencia Técnica", desc: "Consultores integrados a sus equipos para reforzar una competencia escasa." },
      m2: { title: "Centros de Servicios", desc: "Equipos liderados por Hecnos, en run o build, con compromisos de servicio." },
      m3: { title: "Proyectos a Precio Fijo", desc: "Compromiso sobre alcance, plazo y presupuesto. Riesgo controlado." },
    },
    pillars: {
      p1: { title: "Experiencia colectiva", desc: "Seniors que ya han entregado. Sin perfiles en formación disfrazados de consultores." },
      p2: { title: "Experiencia singular", desc: "Movilidad interna, comunidades de experiencia, formación continua, mentoría." },
      p3: { title: "Mentalidad innovadora", desc: "I+D interno, vigilancia activa, prototipado rápido. La innovación como método." },
    },
    blog: {
      heroKicker: "Blog Hecnos",
      heroTitle1: "Insights, tutoriales y",
      heroTitle2: "actualidad tech.",
      heroDesc: "Buenas prácticas de ciberseguridad, tendencias de IA, arquitecturas Big Data y novedades del mundo IT — seleccionadas por nuestro colectivo.",
      all: "Todos",
      categories: { cyber: "Ciberseguridad", ai: "IA", bigdata: "Big Data", it: "IT" },
      featured: "Destacado",
      videoTutos: "Tutoriales en vídeo",
      latest: "Últimos artículos",
      readTime: "min de lectura",
      noResults: "Aún no hay artículos en esta categoría.",
    },
    contact: {
      kicker: "Contacto",
      titleA1: "Hablemos de", titleA2: "su proyecto",
      titleB1: "Únase", titleB2: "al colectivo",
      desc: "Cuéntenos su necesidad o su perfil. Un miembro de nuestro equipo le responderá personalmente en 24 horas laborables.",
      tabContact: "Iniciar un proyecto",
      tabJoin: "Únase a la aventura",
      name: "Nombre completo *",
      email: "Email *",
      company: "Empresa",
      phone: "Teléfono",
      subject: "Asunto",
      subjectJoin: "Puesto buscado",
      message: "Su mensaje *",
      messageJoin: "Preséntese *",
      placeholderMessage: "Describa su contexto, su necesidad y sus retos.",
      placeholderJoin: "Trayectoria, experiencia, motivaciones...",
      gdpr: "Al enviar este formulario acepta que Hecnos trate sus datos para responder a su solicitud, según nuestra política de privacidad.",
      successTitle: "Mensaje recibido",
      successDesc: "Le responderemos en 24 horas laborables.",
      sendAnother: "Enviar otro mensaje",
      findUs: "Encuéntrenos",
      findUsDesc: "Tres oficinas, un solo colectivo.",
      addresses: "Direcciones",
      response: "Respuesta",
      toastSuccess: "Mensaje enviado. Le responderemos en 24h.",
      toastError: "Ocurrió un error. Inténtelo de nuevo en un momento.",
      toastValidation: "Por favor complete nombre, email y mensaje.",
    },
    footer: {
      tagline: "Hecnos es un colectivo de expertos al servicio de organizaciones que quieren resolver retos complejos y acelerar su transformación.",
      company: "Empresa",
      expertises: "Experiencias",
      joinTitle: "Únase",
      joinDesc: "Contratamos talentos que marcan la diferencia.",
      rights: "Todos los derechos reservados.",
      tag: "Consultoría · Tecnología · Talento",
      privacy: "Política de privacidad",
      terms: "Condiciones de uso",
    },
  },

  zh: {
    nav: { home: "首页", expertise: "专业领域", models: "合作模式", why: "为何选择 Hecnos", blog: "博客", contact: "联系我们" },
    cookie: {
      title: "我们尊重您的隐私",
      body: "本网站使用 Cookie 和连接跟踪器来衡量访问量并改善体验。根据 GDPR,任何跟踪器设置前均需获得您的同意。",
      accept: "接受",
      decline: "不接受并继续",
      linkPrivacy: "了解更多",
    },
    sectors: ["银行", "保险", "能源", "零售", "工业", "医疗健康", "电信", "航空航天", "公共部门"],
    common: {
      startProject: "启动项目",
      joinAdventure: "加入我们",
      seeAll: "查看全部",
      learnMore: "了解更多",
      readArticle: "阅读文章",
      watchVideo: "观看视频",
      next: "下一步",
      sendMessage: "发送消息",
      sending: "发送中...",
      response24h: "24 小时内回复(工作日)",
      backToBlog: "返回博客",
    },
    hero: {
      badge: "专家集体。坚定执行,毫不妥协。",
      title1: "携手解决",
      title2: "您最",
      title3: "复杂的挑战",
      desc: "Hecnos 汇聚网络安全、大数据、人工智能与项目管理领域的专家,为高要求企业加速业务转型。",
      state: "团队状态",
      available: "可用 · 2026 Q1",
    },
    sections: {
      expertiseKicker: "专业领域",
      expertiseTitle1: "四大专业。",
      expertiseTitle2: "同一卓越标准。",
      expertiseDesc: "我们将力量集中于价值最大化之处:保护、利用、增强与引领。我们的顾问驻场或远程交付战略级项目。",
      figuresKicker: "关键数据",
      figuresTitle: "覆盖欧洲的规模与执行力。",
      modelsKicker: "合作模式",
      modelsTitle: "三种协作方式。",
      modelsDesc: "根据您的需求成熟度与风险偏好,我们调整合作模式 —— 从专项加固到全程交付。",
      whyKicker: "为何选择 Hecnos",
      whyTitle1: "一个集体。",
      whyTitle2: "不是金字塔。",
      whyDesc: "我们的文化基于三大支柱:真实专业、独特员工体验、持续创新思维。",
      testiKicker: "客户证言",
      testiTitle: "信任我们的人这样说。",
      ctaTitle: "聊聊您的下一个挑战。",
      ctaDesc: "无论保护、利用还是增强 —— 我们都有合适的团队。",
    },
    stats: { experts: "位专家", countries: "个国家", clients: "家客户", projects: "个交付项目" },
    expertises: {
      cyber: { title: "网络安全", short: "SOC、治理、审计、事件响应及 ISO 27001 / NIS2 合规。" },
      bigdata: { title: "大数据", short: "数据平台、Lakehouse 架构、实时摄取及工业化 MLOps。" },
      ai: { title: "人工智能", short: "LLM、RAG、计算机视觉与企业级自动化。" },
      pm: { title: "项目管理", short: "PMO、敏捷方法、关键项目治理与变革管理。" },
    },
    models: {
      m1: { title: "技术支援", desc: "顾问驻派您的团队,补齐稀缺技能。" },
      m2: { title: "服务中心", desc: "由 Hecnos 主导的运营或建设团队,带可衡量的 SLA。" },
      m3: { title: "整包项目", desc: "按范围、时间、预算签订承诺。风险可控。" },
    },
    pillars: {
      p1: { title: "集体专业", desc: "已交付过的资深专家。没有伪装成顾问的实习生。" },
      p2: { title: "独特体验", desc: "内部流动、专业社区、持续学习、导师机制。" },
      p3: { title: "创新心态", desc: "内部研发、主动情报、快速原型。把创新当方法。" },
    },
    blog: {
      heroKicker: "Hecnos 博客",
      heroTitle1: "洞察、教程与",
      heroTitle2: "技术资讯。",
      heroDesc: "网络安全最佳实践、AI 趋势、大数据架构与 IT 新闻 —— 由我们的集体精选。",
      all: "全部",
      categories: { cyber: "网络安全", ai: "人工智能", bigdata: "大数据", it: "IT" },
      featured: "推荐",
      videoTutos: "视频教程",
      latest: "最新文章",
      readTime: "分钟阅读",
      noResults: "该分类下暂无文章。",
    },
    contact: {
      kicker: "联系",
      titleA1: "聊聊", titleA2: "您的项目",
      titleB1: "加入", titleB2: "我们的集体",
      desc: "告诉我们您的需求或您的简历。我们团队成员将在 24 工作小时内亲自回复。",
      tabContact: "启动项目",
      tabJoin: "加入我们",
      name: "姓名 *",
      email: "邮箱 *",
      company: "公司",
      phone: "电话",
      subject: "主题",
      subjectJoin: "意向职位",
      message: "您的留言 *",
      messageJoin: "自我介绍 *",
      placeholderMessage: "描述您的背景、需求与挑战。",
      placeholderJoin: "履历、专长、动机...",
      gdpr: "提交此表即表示您同意 Hecnos 根据隐私政策处理您的数据以回应您的请求。",
      successTitle: "已收到您的消息",
      successDesc: "我们将在 24 工作小时内回复。",
      sendAnother: "再发送一条消息",
      findUs: "找到我们",
      findUsDesc: "三个办公室,同一个集体。",
      addresses: "地址",
      response: "回复",
      toastSuccess: "消息已发送。我们将在 24 小时内回复。",
      toastError: "发生错误,请稍后再试。",
      toastValidation: "请填写姓名、邮箱与留言。",
    },
    footer: {
      tagline: "Hecnos 是一个专家集体,服务希望解决复杂挑战并加速转型的组织。",
      company: "公司",
      expertises: "专业领域",
      joinTitle: "加入我们",
      joinDesc: "我们招募有所不同的人才。",
      rights: "保留所有权利。",
      tag: "咨询 · 技术 · 人才",
      privacy: "隐私政策",
      terms: "使用条款",
    },
  },
};

export const LANGS = [
  { code: "fr", label: "Français", short: "FR" },
  { code: "en", label: "English", short: "EN" },
  { code: "es", label: "Español", short: "ES" },
  { code: "zh", label: "中文", short: "中" },
];
